import React from "react";
import { createBrowserRouter } from "react-router-dom";
import * as Page from "pages";
import * as AdminPage from "adminpages";

const router = createBrowserRouter([
  //end user
  {
    path: "/login",
    element: <Page.LoginV3 />,
  },

  {
    path: "/verify-otp",
    element: <Page.PasswordV3 />,
  },
  {
    path: "/schedule",
    element: <Page.Scheduler />,
  },
  {
    path: "/old-home",
    element: <Page.Home />,
  },
  {
    path: "/transactions",
    element: <Page.Transactions />,
  },
  {
    path: "/exchange",
    element: <Page.Bitcoin />,
  },
  {
    path: "/transactions/b2c",
    element: <Page.Bitcoin />,
  },
  {
    path: "/profile",
    element: <Page.Profile />,
  },
  {
    path: "/investments",
    element: <Page.Investments />,
  },

  // CLIENT NEW ROUTES
  {
    path: "/",
    element: <Page.OverView />,
  },
  {
    path: "/balance-and-movements",
    element: <Page.BalanceAndMovements />,
  },
  {
    path: "/interest-and-fees",
    element: <Page.InterestAndFees />,
  },
  {
    path: "/reports-panel",
    element: <Page.ReportsPanel />,
  },
  {
    path: "/new-payment",
    element: <Page.NewPayment />,
  },
  {
    path: "/request-appointment",
    element: <Page.RequestAppointment />,
  },
  {
    path: "/calendar-appointments",
    element: <Page.MyCalendar />,
  },
  {
    path: "/all-notifications",
    element: <Page.Notifications />,
  },
  {
    path: "/balance-sheet",
    element: <Page.BalanceSheet />,
  },
  {
    path: "/personal-data",
    element: <Page.PersonalData />,
  },
  {
    path: "/privacy-and-consent",
    element: <Page.PrivacyAndConsent />,
  },
  {
    path: "/passwords",
    element: <Page.Passwords />,
  },
  {
    path: "/alert-panel",
    element: <Page.SettingsAlertPanel />,
  },
  {
    path: "/scheduled-payments",
    element: <Page.ScheduledPayments />,
  },
  {
    path: "/insurance/get-a-quote",
    element: <Page.GetAQuote />,
  },

  //admin
  {
    path: "/admin/Home",
    element: <AdminPage.AdminHome />,
  },
  {
    path: "/admin/Transactions",
    element: <AdminPage.LatestTransctions />,
  },
  {
    path: "/admin/Transactions/:id",
    element: <AdminPage.AdminTransactions />,
  },
  {
    path: "/admin/Profile",
    element: <AdminPage.AdminProfile />,
  },
  {
    path: "/admin/create-client",
    element: <AdminPage.CreateClient />,
  },
  {
    path: "/admin/update-client/:id",
    element: <AdminPage.UpdateClient />,
  },
  {
    path: "/settings",
    element: <AdminPage.Settings />,
  },
  {
    path: "/calendar",
    element: <AdminPage.Calendar />,
  },
]);

export default router;
